/**
 * Snackbar Message Format
 *
 * Icon Selections:
 * error, info, success, warning
 *
 * @param type string
 * @param message string
 */
export class SnackBarContent {
  type: string;
  message: string;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/snackbar-format.ts